import React, { memo } from 'react';

import Dialog from '@smart-tv/components/dialog/dialog';
import DialogContent from '@smart-tv/components/dialog/dialog-content';
import Typography from '@smart-tv/components/typography/typography';

import styles from './cookie-banner.module.scss';

interface CookieInformation {
  company: string;
  purpose: string;
  privacy: string;
  expiration: string;
  name: string;
  provider: string;
}

const GOOGLE_ANALYTICS = {
  company: 'Google Analytics',
  purpose:
    'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
  privacy: 'https://policies.google.com/technologies/partner-sites?hl=en',
  provider: 'norlysplay.dk'
};

const HOTJAR = {
  company: 'Hotjar',
  purpose:
    'Indsamler oplysninger om brugerne og deres aktivitet på websitet gennem indlejrede elementer med det formål at analysere og rapportere.',
  privacy: 'https://www.hotjar.com/legal/policies/privacy',
  provider: 'norlysplay.dk'
};

const COOKIES_INFORMATION: CookieInformation[] = [
  { ...GOOGLE_ANALYTICS, expiration: 'to år', name: '_ga' },
  { ...GOOGLE_ANALYTICS, expiration: 'et minut', name: '_gat' },
  { ...GOOGLE_ANALYTICS, expiration: 'en dag', name: '_gid' },
  { ...HOTJAR, expiration: 'et år', name: '_hjid' },
  { ...HOTJAR, expiration: 'et år', name: '_hjTLDTest' }
];

const HEADERS: Record<keyof CookieInformation, string> = {
  company: 'Databehandler',
  purpose: 'Formål',
  privacy: 'Privatlivspolitik',
  expiration: 'Udløb',
  name: 'Navn',
  provider: 'Udbyder'
};

interface Props {
  open: boolean;
  onClose: () => void;
}

export const CookieBannerDialog = (props: Props) => {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className={styles['cookie-banner-dialog']}>
        {COOKIES_INFORMATION.map((cookie) => (
          <div key={cookie.name} className={styles['cookie-banner-dialog__section']}>
            {(Object.keys(HEADERS) as (keyof CookieInformation)[]).map((key) => (
              <Typography key={key} variant="bodySmall">
                <span className={styles['cookie-banner-dialog__label']}>{HEADERS[key]}:&nbsp;</span>
                {key === 'privacy' ? (
                  <a
                    className={styles['cookie-banner__link']}
                    href={cookie.privacy}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {cookie.privacy}
                  </a>
                ) : (
                  cookie[key]
                )}
              </Typography>
            ))}
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default memo(CookieBannerDialog);
